// Should only be used here, reason being that we want this info hard coded in only one place, so that if something changes it only gets updated there
import problemsJSON from "./Problems.json" 



// ------------------------------------------- Methods related to ProblemsJSON ------------------------------------------------------

const problemsMap = problemsJSON.reduce((acc, curr) => {
    acc[curr.problem_id] = curr
    return acc;
}, {})


export function getProblemById(problemID){
    try{
        return problemsMap[problemID];
    }catch(err){
        console.log("[ERROR] Finding problem, most likely your problem id (", problemID, ") is incorrect.");
        return null;
    }
}

export function getExpectedOutput(problemID){
    try{
        return problemsMap[problemID]?.expected_output;
    }catch(err){
        console.log("[ERROR] Finding expected output, most likely your problem id (", problemID, ") is incorrect or this is MCQ question.");
        return null;
    }
}

export function getPossibleLanguagesForProblemAsInt(problemID){
    try{
        return problemsMap[problemID]?.language_ids;
    }catch(err){
        console.log("[ERROR] Finding possible languages: ", err)
        return []
    }
}
// -----------------------------------------------------------------------------------------------------------------------------------









// ------------------------------------------- Methods that map laguages to something ------------------------------------------------


const all_langs = [
    {
        "id": 105,
        "name": "C++",
        "suffix": ".cpp"
    },
    {
        "id": 91,
        "name": "Java",
        "suffix": ".java"
        
    },
    {
        "id": 113,
        "name": "Python",
        "suffix" : ".py"
    }
]



const LanguageIDMap = all_langs.reduce((acc, curr) =>{
    acc[curr.id] = curr.name
    acc[curr.name] = curr.id
    return acc;
}, {});



const FileSuffixMap = all_langs.reduce((acc, curr) =>{
    acc[curr.id] = curr.suffix
    acc[curr.name] = curr.suffix

    return acc;
}, {});


export function getLanguageIDByName(languageName){
    if(typeof languageName !== String) throw new TypeError("Input to getLanguageIDByName should be type String");
    return LanguageIDMap[languageName];
}

export function getLanguageNameByID(languageID){
    if(typeof languageID !== Number) throw new TypeError("Input to getLanguageIDByName should be type number");
    return LanguageIDMap[languageID];
}


export function getLanguageByID(id){
    try{
        return LanguageIDMap[id]
    } catch(err){
        console.log("[ERROR] Couldnt find the corresponding language: ", err);
    }
} 

export function getLanguageIDbyName(name) {
    try{
        return LanguageIDMap[name];
    } catch(err){
        console.log("[ERROR] Couldnt find the corresponding language: ", err);
    }
}

export function getFileSuffixByLanguageID(id){
    try{
        return FileSuffixMap[id];
    } catch(err){
        
        console.log("[ERROR] Did not find suffix corresponding to id: ", id, " Message: ", err)
    }
}

export function getStringLanguageNameByLanguageID(id){
    try{
        return LanguageIDMap[id];
    } catch(err){
        
        console.log("[ERROR] Did not language corresponding to id: ", id, " Message: ", err)
    }
}


// ------------------------------------------------------------------------------------------------------------------------------------
